import { RecipeSource } from '@/types/recipe';
import { Sparkles, User, Copy, Bot, FileText } from 'lucide-react';

export const RECIPE_SOURCE_CONFIG = {
  [RecipeSource.Studio]: { icon: Sparkles, color: 'text-terracotta-500', tooltip: 'Created with ChefLab Studio' },
  [RecipeSource.User]: { icon: User, color: 'text-sage-500', tooltip: 'User Created' },
  [RecipeSource.Copied]: { icon: Copy, color: 'text-sage-600', tooltip: 'Copied from another recipe' },
  [RecipeSource.Assistant]: { icon: Bot, color: 'text-terracotta-400', tooltip: 'Created by AI assistant' },
  [RecipeSource.Imported]: { icon: FileText, color: 'text-stone-500', tooltip: 'Imported from file' },
};

export const DEFAULT_SOURCE_CONFIG = RECIPE_SOURCE_CONFIG[RecipeSource.User];
